// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"106":"d6d49dc0","116":"5f0927e5","135":"a93da5a3","286":"0741b8e0","316":"de408b55","557":"92efa2f3","686":"47619726","780":"4592fc45","857":"5d503c45","875":"33442aaf"}[chunkId] + ".chunk.js";
};